import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardImg } from 'reactstrap';
import { Link } from 'react-router-dom';

const HomeGalleryItem = ({ item }) => (
  <div className="home-gallery-item">
    <Card>
      <Link to={item.url}>
        <CardImg
          className="image"
          src={item.image}
        />
        <div className="content" />
      </Link>
    </Card>
  </div>
);

HomeGalleryItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

export default HomeGalleryItem;
